





import {Component, Vue, Inject, Emit, Prop} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import {API_ChangePassword, API_GetSmsCaptcha, API_Register} from "@/api/login";
import ajaxHelperInstance from "@/lib/ajaxhelper";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

@Component({
    components: {}
})
export default class QRLoginForm extends AbpBase {
    @Prop({type:Object,default:()=>{return {}}})
    provideInfo:any;

    form: any;
    formItemLayout = formItemLayout;

    state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
    }

    beforeCreate() {
        this.form = this.$form.createForm(this);
    }


    getWXQRCode(){
        let WxLogin:any = window['WxLogin'];
        ajaxHelperInstance.get("/web/auth/getStateWx").then((res)=>{
            let {data,errno,message} = res.data;
            if(errno!=0){
                this.$message.info(message);
                return;
            }

            // let redirectUrl = ''

            let redirectUrl = 'http://www.yntrxxh.com/#/wxredirect';
            redirectUrl = encodeURIComponent(redirectUrl);

            var obj = new WxLogin({
                self_redirect: false,
                id: 'wxLoginContainer',
                appid: 'wxeb1407752793f44d',
                scope: 'snsapi_login',
                redirect_uri: redirectUrl,
                state: data.uuid
            });
        })
    }

    mounted(){
        this.getWXQRCode();
    }

    @Emit("registerEnd")
    registerEnd(){
        return 1
    }


}
